import { render, staticRenderFns } from "./MediaManager.vue?vue&type=template&id=0835150c&scoped=true&"
import script from "./MediaManager.vue?vue&type=script&lang=js&"
export * from "./MediaManager.vue?vue&type=script&lang=js&"
import style0 from "./MediaManager.vue?vue&type=style&index=0&id=0835150c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835150c",
  null
  
)

export default component.exports